<template>
    <el-dialog v-model="visible" title="Yeni məhkəmə işi" width="35%" top="70px">
        <div class="mb-3">
            <label class="form-label">Hakim</label>
            <el-input v-model="judge" size="large" />
        </div>

        <div class="mb-3">
            <label class="form-label">Məhkəmə</label>
            <el-select v-model="selectedCourtId" placeholder="Seçin" size="large" style="width: 100%;">
                <el-option v-for="court in courts" :key="court.id" :label="court.name" :value="court.id" />
            </el-select>
        </div>

        <div class="mb-3">
            <label class="form-label">Məhkəmə icraçısı</label>
            <el-input v-model="executor" size="large" />
        </div>

        <div class="mb-3">
            <label class="form-label">Əlaqə nömrəsi(Məhkəmə icraçısı)</label>
            <el-input v-model="executorPhone" v-mask="'+994 (##) ###-##-##'" size="large" type="tel"
                placeholder="+994 xx xxx xx xx" />
        </div>

        <div class="mb-3">
            <label class="form-label">Məhkəməyə qədər xərclər</label>
            <el-input v-model.number="preCourtExpense" type="number" min="0" size="large" />
        </div>

        <div class="mb-3">
            <label class="form-label">Tələb olunan məbləğ</label>
            <el-input v-model.number="demandedAmount" type="number" min="0" size="large" />
        </div>

        <div class="d-flex justify-content-end mt-4">
            <soft-button type="button" @click="saveCourt">Yadda saxla</soft-button>
            &nbsp;
            <soft-button type="button" color="secondary" @click="$emit('update:modelValue', false)">İmtina</soft-button>
        </div>
    </el-dialog>
</template>

<script>
import SoftButton from "@/components/SoftButton.vue";
import { GetParticipants } from "@/project/Source/participants";
import { CreateCourtCase } from "@/project/Source/courts";
import { GetCourts } from "@/project/Source/classifiers";
import { mask } from "vue-the-mask";

export default {
    directives: {
        mask,
    },
    components: { SoftButton },
    props: {
        modelValue: Boolean,
        subrogationId: { type: [String, Number], required: true }
    },
    emits: ["update:modelValue", "saved"],
    data() {
        return {
            selectedParticipantId: null,
            selectedCourtId: null,
            judge: "",
            executor: "",
            executorPhone: "",
            participants: [],
            courts: [],
            preCourtExpense: null,
            demandedAmount: null,
            loading: false
        };
    },
    computed: {
        visible: {
            get() { return this.modelValue; },
            set(v) { this.$emit("update:modelValue", v); }
        }
    },
    watch: {
        modelValue(val) {
            if (val) {
                this.selectedParticipantId = null;
                this.selectedCourtId = null;
                this.executor = "";
                this.executorPhone = "";
                this.judge = "";
                this.preCourtExpense = null;
                this.demandedAmount = null;
                this.loadParticipants();
                this.fetchCourts();
            }
        }
    },
    methods: {
        loadParticipants() {
            this.loading = true;
            GetParticipants(this.subrogationId)
                .then(res => { this.participants = res.data.data || []; })
                .catch(() => { this.$message.error("Xəta baş verdi"); })
                .finally(() => { this.loading = false; });
        },
        fetchCourts() {
            this.loading = true;
            GetCourts()
                .then(res => { this.courts = res.data.data || []; })
                .catch(() => { this.$message.error("Məhkəmələr yüklənə bilmədi"); })
                .finally(() => { this.loading = false; });
        },
        saveCourt() {
            if (!this.selectedCourtId) { this.$message.warning("Zəhmət olmasa məhkəməni seçin."); return; }
            if (!this.judge) { this.$message.warning("Zəhmət olmasa hakimi daxil edin."); return; }
            if (!this.executor) { this.$message.warning("Zəhmət olmasa icraçını daxil edin."); return; }
            if (!this.executorPhone) { this.$message.warning("İcraçının əlaqə nömrəsini daxil edin."); return; }
            const phone = this.executorPhone.trim();
            if (!/^[\d+\-\s()]{7,20}$/.test(phone)) { this.$message.warning("Telefon formatı yanlışdır."); return; }

            const courtCaseData = {
                subrogationId: this.subrogationId,
                courtId: this.selectedCourtId,
                judge: this.judge,
                executor: this.executor,
                executorPhone: phone,
                preCourtExpense: this.preCourtExpense,
                demandedAmount: this.demandedAmount,
                createUser: this.$store.state.user.id
            };

            CreateCourtCase(courtCaseData)
                .then(() => {
                    this.$message.success("Uğurlu əməliyyat!");
                    this.visible = false;
                    this.$emit("saved");
                })
                .catch(() => { this.$message.error("Xəta baş verdi."); })
                .finally(() => { this.loading = false; });
        }
    }
};
</script>
